import React, { useState, useEffect, useContext, useRef, memo } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Loader from "../../../Setup/views/Loader";
import useFormSubmission from '../../../Auth/Controller/AuthController';
import ModuleService from '../../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../../Layout/SidebarContext';
import BASE_URL from "../../../../config/config";
// Import FullCalendar and plugins
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable as interactionDraggable } from '@fullcalendar/interaction'; // For drag and drop
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import JobService from "../../../Jobs/Controller/JobController";
import TeamService from "../../../Setup/controller/TeamController/TeamController";
import UserService from "../../../Setup/controller/UserController/UserController";
import { CreateEngineer } from "../../../Jobs/Controller/CreateJobEngineerController";
import { handleChange, handleUpdate } from "../../../Jobs/Controller/UpdateEngineerTimeController";
import Common from '../../../Common/Common';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ProjectService from "../../../Setup/controller/ProjectMemberController/ProjectMemberController";
import DiariesLabelService from "../../../Setup/controller/DiariesLabelController/Controller/DiariesController";
import Swal from 'sweetalert2';
/// Shahid---------------------

import CustomerHistoryService from "../../../Customer/Controller/CustomerHistoryController";
import Draggable from 'react-draggable';
import CreateCommunication from "./CreateCommunication";
import MultiSelectDropdown from "./MultiSelectDropdown";
function DiariesView({ close, onSuccess }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const navigate = useNavigate();
    const { updateSidebarModules } = useContext(SidebarContext);
    const RoleName = localStorage.getItem('RoleName');

    const UserID = localStorage.getItem('UserID');
    const HelpLink = localStorage.getItem('HelpLink');
    const [formData, setFormData] = useState({});
    const location = useLocation();
    const url = new URL(window.location.origin + location.pathname);
    const pathname = url.pathname;
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const IsAdminLogin = localStorage.getItem('IsAdminLogin');
    const handleSubmit = useFormSubmission();
    const [errorMessage, setErrorMessage] = useState('');
    const [teams, setTeams] = useState([]);
    const [users, setUsers] = useState([]);
    const [userList, setUserList] = useState([]);
    // State to hold calendar events
    const [events, setEvents] = useState([]);


    // State to control calendar view (Week, Day, Month)
    const [calendarView, setCalendarView] = useState('timeGridWeek'); // Default to weekly view

    // State for slot duration
    const [slotDuration, setSlotDuration] = useState('01:00:00'); // Default to 1 hour
    const [EventType, setEventType] = useState('All');
    const [selectedTeam, setSelectedTeam] = useState(0);
    // State to control sidebar visibility
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('engineers');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
    const calendarRef = useRef(null);
    const [ProjectList, setProject] = useState([]);
    const [ProjectID, setProjectID] = useState(localStorage.getItem("ProjectID") || ""); // Initial empty state
    const [jobList, setJobData] = useState([]);
    const [filteredJobList, setFilteredJobList] = useState([]); // Filtered job list
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null); // or initialize with the default job
    const [selectedUser, setSelectedUser] = useState(null); // or initialize with the default user
    const [selectedProject, setSelectedProject] = useState(''); // or initialize with the default project
    const [Weekened, setWeekened] = useState(true);
    const [loading, setLoading] = useState(true);
    const [timeOption, setTimeOption] = useState('workingHours');
    const [DiariesLabel, setDiariesLabel] = useState('Engineers');
    const [assignedEngineers, setAssignedEngineers] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
    const [TaskList, setTaskList] = useState([]);
    const [AppointmentList, setAppointmentList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isJobModalOpen, setIsJobModalOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
    // const [LeadID, setLeadID] = useState('0');
    const [OpportunityID, setOpportunityID] = useState('0');
    const [ClientCompanyID, setClientCompanyID] = useState('0');
    const [SupplierID, setSupplierID] = useState('0');
    const [taskID, setTaskID] = useState('0');
    const [selectedEvent, setSelectedEvent] = useState(null);
    useEffect(() => {

        const fetchProject = async () => {
            try {
                const redirectCallback = () => navigate('/');

                const list = await ProjectService.GetProjectMemberByID(redirectCallback);

                const filteredList = list.filter(project => project.ID !== 0); // Remove project with ID 0
                setProject(filteredList[0]);

                if (filteredList.length > 0) {
                    let initialProjectID;

                    // Look for a default project
                    const defaultProjectList = filteredList[0].filter(project => project.IsDefault === "1" || project.IsDefault === 1);
                    if (defaultProjectList.length > 0) {
                        initialProjectID = defaultProjectList[0].ID;
                    } else {
                        // Set to the first project in the filtered list
                        initialProjectID = filteredList[0].ID;
                    }
                    setProjectID(initialProjectID);
                    localStorage.setItem("ProjectID", initialProjectID);
                    await fetchJob(initialProjectID);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProject();

    }, []);

    useEffect(() => {
        IsModuleAssigned();
        fetchJobEngineers();
        fetchTeams();
        fetchDiariesLabel();
        fetchAllUsers();
        //  fetchTask();
        //  fetchAppointments();
    }, [theme]);
    useEffect(() => {
        const loggedInUserID = localStorage.getItem("UserID");
        if (userList.length > 0 && loggedInUserID) {
            const preSelected = userList.find(u => u.UserID.toString() === loggedInUserID.toString());
            if (preSelected) {
                setSelectedUsers([preSelected.UserID.toString()]); // 🟦 Store as string to match selected value
            }
        }
    }, [userList]);
    useEffect(() => {
        IsModuleAssigned();
        if (teams.length > 0 && selectedTeam === 0) {
            // Set the first team as selected and fetch users for it
            const initialTeamID = teams[0].PK_Team_ID;
            setSelectedTeam(initialTeamID);
            fetchUsers(initialTeamID);
        }
    }, [teams]);
    const fetchTeams = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const teamData = await TeamService.GetAllTeams(redirectCallback);
            setTeams(teamData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchTask = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const taskData = await JobService.TaskForDiaries(redirectCallback);
            setTaskList(taskData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchAppointments = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobService.AppointmentsForDiaries(redirectCallback);
            setAppointmentList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchDiariesLabel = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const ClientID = localStorage.getItem('CompanyID');
            const diaireLabel = await DiariesLabelService.GetDiariesLabel(redirectCallback, ClientID);
            if (diaireLabel.length > 0) {
                setDiariesLabel(diaireLabel[0].DiariesLable);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleTeamChange = (event) => {
        const { value } = event.target;
        setSelectedTeam(value);
        setSelectedUser(null);
        fetchUsers(value);
    };
    const fetchUsers = async (TeamID) => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.fetchUserByTeam(redirectCallback, TeamID);
            // Creating a new array with different attribute names
            const myusers = usersData.map(user => ({
                title: user.DisplayName,  // Change 'title' to 'name'
                color: user.Color,  // Change 'color' to 'backgroundColor'
                id: user.UserID  // Change 'id' to 'identifier'
            }));
            setUsers(myusers);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const fetchAllUsers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.AllowedDiaryUsers(redirectCallback);
            setUserList(usersData);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const handleChanges = (event, formData, setFormData) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFieldChange = (event) => {

        handleChanges(event, formData, setFormData);
        if (event.target.name === "ProjectID") {
            setProjectID(event.target.value);
            setSelectedProject(event.target.value);
            setSelectedJob(null);
            fetchJob(event.target.value);
        }
    };
    const fetchJob = async (projectID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const jobsData = await JobService.GetAllJobs(redirectCallback, 0, 0, 0, 0, projectID, 0, "5000", "", "IssueID", "DESC");
            setJobData(jobsData);
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    };
    const fetchJobEngineers = async () => {
        setLoading(true);
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);
            const filteredEngineers = jobEngineers.filter(engineer => engineer.UserID == UserID);
            const formattedEvents = filteredEngineers.map(engineer => ({
                title: engineer.IssueTitle, // Modify as per your data structure
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),  // Ensure the time format is compatible with FullCalendar
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job",
            }));

            const taskData = await JobService.TaskForDiaries(redirectCallback);
            const filteredTasks = taskData.filter(tas => tas.AssignUserID == UserID);
            const taskEvents = filteredTasks.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),

                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));

            const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);
            const filteredAppointments = appointmentData.filter(app => app.AssignUserID == UserID);
            const appointmentEvents = filteredAppointments.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "opportunity"
            }));

            setEvents([...formattedEvents, ...taskEvents, ...appointmentEvents]);
            // setEvents(formattedEvents); // Update state with the fetched events
        } catch (error) {
            console.error('Error fetching job engineers:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };


    const handleDateClick = (arg) => {
        const date = new Date(arg.dateStr);
        const padZero = (num) => (num < 10 ? `0${num}` : num);
        const start = new Date(date);
        const end = new Date(date);
        end.setHours(end.getHours() + 1);

        const newEvent = {
            id: 'temp', // Unique temp ID
            title: "New Slot",
            start,
            end,
            backgroundColor: "#00b894",
            description: "Newly Selected Slot",
            UserID: selectedUsers[0],
            eventType: "custom",
        };

        setEvents((prevEvents) => {
            // Remove any existing 'temp' event
            const filtered = prevEvents.filter(e => e.id !== 'temp');
            return [...filtered, newEvent];
        });

        setSelectedEvent(newEvent); // highlight the new slot
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleSuccess = async () => {

        await fetchJobEngineers(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    // Handle dropdown change for calendar view
    const handleViewChange = (e) => {
        const selectedValue = e.target.value;

        // Handle "Work Week" case by setting view and hiding weekends
        if (selectedValue === 'workWeek') {
            setCalendarView('timeGridWeek'); // Display timeGridWeek for work week
            setWeekened(false); // Hide weekends for work week
        } else {
            setCalendarView(selectedValue); // Update to the selected view
            setWeekened(true); // Show weekends for other views like "Full Week"
        }
    };

    // Handle dropdown change for slot duration
    const handleSlotDurationChange = (e) => {
        setSlotDuration(e.target.value);
    };
    const handleEventType = async (e) => {

        const selectedType = e.target.value; // Get the selected type
        //  setSelectedUsers([]);
        setEventType(selectedType);
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);

        const formattedEvents = jobEngineers
            .filter(engineer => selectedUsers.includes(String(engineer.UserID)))
            .map(engineer => ({
                title: engineer.IssueTitle,
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job"
            }));

        const taskData = await JobService.TaskForDiaries(redirectCallback);

        const taskEvents = taskData
            .filter(task => selectedUsers.includes(String(task.AssignUserID)))
            .map(task => ({
                title: task.Type,
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));
        const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);
        const appointmentEvents = appointmentData
            .filter(appointment => selectedUsers.includes(String(appointment.AssignUserID)))
            .map(appointment => ({
                title: appointment.Type,
                start: appointment.StartTime ? new Date(appointment.StartTime.replace("Z", "")) : new Date(),
                end: appointment.EndTime ? new Date(appointment.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: appointment.Color,
                description: appointment.vc_Description,
                IssueID: appointment.ID,
                UserID: appointment.LeadID,
                EngineerTimeID: appointment.ID,
                IsLead: appointment.Lead,
                eventType: "opportunity"
            }));

        if (selectedType === "All") {
            // Show all events
            setEvents([...formattedEvents, ...taskEvents, ...appointmentEvents]);
        } else if (selectedType === "Jobs") {
            // Show only job events
            setEvents(formattedEvents);
        } else if (selectedType === "Tasks") {
            // Show only task events
            setEvents(taskEvents);
        } else if (selectedType === "Appointments") {
            // Show only appointment events
            setEvents(appointmentEvents);
        }
    };
    const handleWeekenedChange = (e) => {
        // Convert the string value to true/false
        const isWeekend = e.target.value === "true";
        setWeekened(isWeekend);  // Set the state with the boolean value
    };

    // Compute slotMinTime and slotMaxTime based on the calendarView and slotDuration
    const computeSlotTimes = () => {
        let slotMinTime = '00:00:00';
        let slotMaxTime = '24:00:00';

        if (calendarView === 'timeGridDay' || calendarView === 'timeGridWeek') {
            // Adjust slotMinTime and slotMaxTime to show the full range if necessary
        }

        return { slotMinTime, slotMaxTime };
    };

    const handleEventRender = (info) => {
       const { eventType } = info.event.extendedProps;
        const iconMap = {
            job: '<i class="icofont-briefcase" style={{ marginRight: "5px" }}></i>',
            task: '<i class="icofont-check" style={{ marginRight: "5px" }}></i>',
            opportunity: '<i class="icofont-clock-time" style={{ marginRight: "5px" }}></i>',
        };

        const iconHtml = iconMap[eventType] || '';
        info.el.querySelector('.fc-event-title').innerHTML = `${iconHtml}${info.event.title}`;

        // Add tooltip and background color
        tippy(info.el, {
            content: info.event.extendedProps.description,
            allowHTML: true,
        });
        info.el.style.backgroundColor = info.event.extendedProps.backgroundColor;

        if (selectedEvent && selectedEvent.id === info.event.id) {
            info.el.style.border = '3px solid #2d3436';
        } else {
            info.el.style.border = 'none';
        }
    };

    const { slotMinTime, slotMaxTime } = computeSlotTimes();

    // Function to toggle sidebar
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const handleTabClick = (tab) => {

        setActiveTab(tab);
    };
    const [checkboxState, setCheckboxState] = useState({});
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };
    // JobController.js
    const handleEventDrop = async (eventDropInfo) => {

        const { id } = eventDropInfo.event;
        const { start, end } = eventDropInfo.event;
        const { eventType } = eventDropInfo.event.extendedProps;

        const formatDateWithoutTimezone = (date) => {
            return new Date(date).toISOString().slice(0, 19).replace("T", " "); // Convert to UTC format
        };

        const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
        };



        if (eventType != "task" && eventType != "opportunity") {
            const JobID = eventDropInfo.event._def.extendedProps.IssueID;
            const UserId = eventDropInfo.event._def.extendedProps.UserID;
            const EngineerTimeID = eventDropInfo.event._def.extendedProps.EngineerTimeID;


            const StartTime = formatDate(new Date(start));
            const EndTime = formatDate(new Date(end));

            const { oldEvent } = eventDropInfo;
            const PreviousStartTime = formatDate(new Date(oldEvent.start));
            const PreviousEndTime = formatDate(new Date(oldEvent.end));

            setAssignedEngineers((prevAssigned) =>
                prevAssigned.map((engineer) =>
                    engineer.id === id
                        ? { ...engineer, StartTime, EndTime } // Update start and end times
                        : engineer
                )
            );

            if (id === "" || parseInt(id) === 0) {
                const data = {
                    JobID,
                    UserId,
                    StartTime,
                    EndTime,
                    PreviousStartTime,
                    PreviousEndTime,
                    EngineerTimeID
                };

                try {
                    const message = await handleUpdate(data);
                    // await fetchJobEngineers();

                } catch (error) {
                    eventDropInfo.revert();
                }
            }
        }
        else if (eventType === "task") {
            eventDropInfo.snt_CommunicationType = "2";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }



            return false;
        } else if (eventType === "opportunity") {

            eventDropInfo.snt_CommunicationType = "3";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);

            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }

            return false;
        }
    };
    const handleDateChange = (event) => {

        const date = event.target.value;
        setSelectedDate(date);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(date); // Navigate to selected date
    };
    const handleRowClick = (userId) => {
        setSelectedUser(userId);
    };
    const redirecttoUnAuthorzied = () => {
        navigate('/Unauthorized'); // Redirect to the login page
    };
    const IsModuleAssigned = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            const Modules = await ModuleService.GetModuleByClientID(CompanyID, "11");
            if (Modules.length === 0) {
                Swal.fire(
                    'UnAuthorzied Access!',
                    'Sorry, You are not authorized to access this module.',
                    'warning'
                );
                redirecttoUnAuthorzied();
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleRowClickIssue = (IssueID) => {
        setSelectedJob(IssueID);
    };



    const userOptions = userList.map(user => ({
        value: user.UserID,
        label: user.DisplayName,
    }));
    const handleUserNameChange = async (selectedValues) => {
        setSelectedUsers(selectedValues);
        // setEventType("Jobs");

        const redirectCallback = () => navigate('/');

        // 🔹 Fetch all data
        const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);
        const taskData = await JobService.TaskForDiaries(redirectCallback);
        const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);

        // 🔹 Filter each based on selectedValues
        const filteredJobs = jobEngineers
            .filter(engineer => selectedValues.includes(String(engineer.UserID)))
            .map(engineer => ({
                title: engineer.IssueTitle,
                start: engineer.StartTime ? new Date(engineer.StartTime.replace("Z", "")) : new Date(),
                end: engineer.EndTime ? new Date(engineer.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID,
                IsLead: "10",
                eventType: "job"
            }));

        const filteredTasks = taskData
            .filter(task => selectedValues.includes(String(task.AssignUserID)))
            .map(task => ({
                title: task.Type,
                start: task.StartTime ? new Date(task.StartTime.replace("Z", "")) : new Date(),
                end: task.EndTime ? new Date(task.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));

        const filteredAppointments = appointmentData
            .filter(appointment => selectedValues.includes(String(appointment.AssignUserID)))
            .map(appointment => ({
                title: appointment.Type,
                start: appointment.StartTime ? new Date(appointment.StartTime.replace("Z", "")) : new Date(),
                end: appointment.EndTime ? new Date(appointment.EndTime.replace("Z", "")) : new Date(),
                backgroundColor: appointment.Color,
                description: appointment.vc_Description,
                IssueID: appointment.ID,
                UserID: appointment.LeadID,
                EngineerTimeID: appointment.ID,
                IsLead: appointment.Lead,
                eventType: "opportunity"
            }));
        if (EventType === "All") {
            // Show all events
            setEvents([...filteredJobs, ...filteredTasks, ...filteredAppointments]);
        } else if (EventType === "Jobs") {
            // Show only job events
            setEvents(filteredJobs);
        } else if (EventType === "Tasks") {
            // Show only task events
            setEvents(filteredTasks);
        } else if (EventType === "Appointments") {
            // Show only appointment events
            setEvents(filteredAppointments);
        }
        //setEvents([...filteredJobs, ...filteredTasks, ...filteredAppointments]);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    };

    const handleEventClick = (clickInfo) => {

        setSelectedEvent(clickInfo.event);
    };
    const handleEventResize = async (resizeInfo) => {
        const updatedEvent = resizeInfo.event;
        const start = new Date(updatedEvent.start);
        const end = new Date(updatedEvent.end);

        updatedEvent.setExtendedProp("resized", true);
        setSelectedEvent(updatedEvent); // mark it as selected
    };
    const handleModalClose = () => {
        if (selectedEvent) {
            const start = selectedEvent.start;
            const end = selectedEvent.end;
            const startDate = start.toISOString().split('T')[0];
            const startTime = start.toTimeString().split(' ')[0];
            const endTime = end.toTimeString().split(' ')[0];
            const userId = selectedEvent.extendedProps?.UserID || selectedEvent.UserID;
            onSuccess(startDate, startTime, endTime, userId);
            setIsModalOpen(false);
            close();
        }
        else {
            Swal.fire(
                'Error!',
                'No time slot has been selected from the calendar.',
                'error'
            );
            setIsModalOpen(false);
            close();
        }

    };
    return (

        <div>



            <div className="modal fade leadDiaryModal show d-block" id="leadDiaryModal" tabIndex="-1" aria-labelledby="leadDiaryModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-lg" style={{ width: "75%", "left": "6vh", top: "2vh" }}>
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Check Availablity </h5>
                                <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card mb-30">
                                            <div className="card-body">
                                                <div className="table-responsive"></div>

                                                <div className="row mb-3">

                                                    <div className="col-sm-2">
                                                        <select className='form-control' id="calendarView" value={calendarView === 'timeGridWeek' && !Weekened ? 'workWeek' : calendarView} onChange={handleViewChange}>
                                                            <option value="timeGridWeek">Full Week</option>
                                                            <option value="workWeek">Work Week</option> {/* Custom Work Week Option */}
                                                            <option value="timeGridDay">Day</option>
                                                            <option value="dayGridMonth">Month</option>
                                                        </select>
                                                    </div>

                                                    <div className="col-sm-2">
                                                        <select className='form-control' id="slotDuration" value={slotDuration} onChange={handleSlotDurationChange}>
                                                            <option value="00:15:00">15 Minutes</option>
                                                            <option value="00:30:00">30 Minutes</option>
                                                            <option value="01:00:00">1 Hour</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <select className='form-control' id="EventType" value={EventType} onChange={handleEventType}>
                                                            <option value="All">All</option>
                                                            <option value="Jobs">Jobs</option>
                                                            <option value="Tasks">Tasks</option>
                                                            <option value="Appointments">Appointments</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <MultiSelectDropdown
                                                            options={userOptions}
                                                            selectedOptions={selectedUsers}
                                                            onChange={handleUserNameChange} // Pass handler here
                                                        />
                                                    </div>
                                                    <div className="col-sm-2">
                                                        {selectedEvent && (
                                                            <button type="button" className="btn btn-danger btn-sm" style={{ padding: "5px 4px" }} aria-label="Close" onClick={handleModalClose}>
                                                                Confirm & Close
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="calendar-container">

                                                    <FullCalendar
                                                        ref={calendarRef}
                                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                        initialView={calendarView}
                                                        view={calendarView}
                                                        editable={true}
                                                        events={events}
                                                        dateClick={handleDateClick}
                                                        slotDuration={slotDuration}
                                                        slotMinTime={slotMinTime}
                                                        slotMaxTime={slotMaxTime}
                                                        scrollTime="08:00:00"
                                                        slotLabelInterval={slotDuration} // Adjust label interval to match slot duration
                                                        key={calendarView}
                                                        eventMouseEnter={handleEventRender}
                                                        eventDidMount={handleEventRender}
                                                        eventDrop={handleEventDrop}
                                                        eventResize={handleEventResize}
                                                        selectable={true}
                                                        eventResizableFromStart={true}
                                                        eventClick={handleEventClick}
                                                        droppable={true}

                                                        weekends={Weekened}
                                                        buttonText={{
                                                            today: 'Today'
                                                        }}
                                                        longPressDelay={1000}
                                                        allDaySlot={false}
                                                        timeZone="local"
                                                    />

                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </div>

        </div>
    );
}
export default DiariesView;